import { Injectable } from '@angular/core';
import { Notification } from '@m4u-angular/base/entities/BaseEntities';
import { AppConfigService } from '@m4u-angular/configuration/app.config.service';
import { ReplaySubject, Subscription } from 'rxjs';
import { PushMessageEndpoint } from '../endpoints/push-message.endpoint';

@Injectable({ providedIn: 'root' })
export class NotificationService {

    private _notificationUnreadSubject = new ReplaySubject<number>(1);
    public readonly NotificationUnread$ = this._notificationUnreadSubject.asObservable();

    private _notificationsSubject = new ReplaySubject<Notification[]>(1);
    public readonly Notifications$ = this._notificationsSubject.asObservable();

    private _notificationReadSubscription: Subscription;
    private _notificationUnReadSubscription: Subscription;
    private _timerId: any;

    constructor(private pushMessageEndpoint: PushMessageEndpoint,
        private appConfigService: AppConfigService) {
    }

    public Start() {
        if (!this.appConfigService.AppConfig.IsAllowNotifications) return;

        this.LoadPushMessagesUnread();
        this._notificationReadSubscription = this.pushMessageEndpoint.NotificationRead$
            .subscribe((result: boolean) => result && this.LoadPushMessagesUnread());
    }

    public LoadPushMessagesUnread() {
        if (!this.appConfigService.AppConfig.IsAllowNotifications) return;

        this._notificationUnReadSubscription = this.pushMessageEndpoint.GetPushMessagesUnread().subscribe((response) => {
            if (!response.IsSuccess) return;
            
            const unreadPushMessages = response.Data as any;

            this._notificationUnreadSubject.next(unreadPushMessages.Item1);
            this._notificationsSubject.next(unreadPushMessages.Item2);

            !this._timerId && (this._timerId = setInterval(() => this.LoadPushMessagesUnread(), 60000));
        })
    }

    public Stop(): void {
        clearInterval(this._timerId);
        this._notificationReadSubscription && !this._notificationReadSubscription.closed && this._notificationReadSubscription.unsubscribe();
        this._notificationUnReadSubscription && !this._notificationUnReadSubscription.closed && this._notificationUnReadSubscription.unsubscribe();
    }
}